import { useSyncExternalStore } from 'react';
import { TERMS_OF_SERVICE_URL } from '../../config';
import {
  getFooterLinksSnapshot,
  subscribeFooterLinks,
} from './footerLinksStore';

/**
 * Terms-of-Service URL for every "Terms of Service" anchor in the iframe
 * (disclaimer modal, refund notice): the operator's footer link tagged
 * `type: 'terms'` when configured, else the static platform default. The
 * store is warmed at app init (ThemedShell), so consumers don't need an
 * ApiClient; while the fetch is in flight the default is shown and the
 * anchor re-renders once the operator link lands.
 */
export function useTermsUrl(): string {
  const links = useSyncExternalStore(subscribeFooterLinks, getFooterLinksSnapshot);
  return links?.find((link) => link.type === 'terms')?.url ?? TERMS_OF_SERVICE_URL;
}
